import styled from 'styled-components';

import {
  AccountDropdownMenuButton,
  AccountDropdownMenuList,
  AccountDropdownMenuListItem,
  AccountDropdownMenuWrapper,
} from 'layout/header/styles/AccountDropdownMenu';
import { UnorderedList } from 'shared/components/UnorderedList';
import { useSitePreferencesModal } from 'shared/hooks/useSitePreferencesModal';
import { useStoreDispatch } from 'store/hooks/storeHooks';
import {
  openCreateAccountModal,
  openLoginModal,
  setDarkTheme,
} from 'store/slice/accountModalSlice';
import { t } from 'localization/utils/t';
import { useWindowSize } from 'shared/hooks/useWindowSize';

const TP = 'layout.header.components.LoggedOutDropdownMenu';

export const LoggedOutDropdownMenu = () => {
  const storeDispatch = useStoreDispatch();
  const { isMobileOrTablet } = useWindowSize();
  const { openSitePreferencesModal } = useSitePreferencesModal();

  const handleCreateAccountClick = () => {
    storeDispatch(setDarkTheme(isMobileOrTablet));
    storeDispatch(openCreateAccountModal());
  };

  const handleLogInClick = () => {
    storeDispatch(setDarkTheme(isMobileOrTablet));
    storeDispatch(openLoginModal());
  };

  return (
    <LoggedOutDropdownMenu.Wrapper>
      <LoggedOutDropdownMenu.List>
        <LoggedOutDropdownMenu.ListItem>
          <LoggedOutDropdownMenu.Button
            data-qa="log_in_menu_button"
            onClick={handleLogInClick}
            type="button"
          >
            {t(`${TP}.logIn`, 'Log In')}
          </LoggedOutDropdownMenu.Button>
        </LoggedOutDropdownMenu.ListItem>
        <LoggedOutDropdownMenu.ListItem>
          <LoggedOutDropdownMenu.Button
            data-qa="create_account_menu_button"
            onClick={handleCreateAccountClick}
            type="button"
          >
            {t(`${TP}.createAccount`, 'Create Account')}
          </LoggedOutDropdownMenu.Button>
        </LoggedOutDropdownMenu.ListItem>
        <LoggedOutDropdownMenu.ListItem>
          <LoggedOutDropdownMenu.Button
            data-qa="location_preference_menu_button"
            onClick={openSitePreferencesModal}
            type="button"
          >
            {t(`${TP}.locationPreferences`, 'Location Preferences')}
          </LoggedOutDropdownMenu.Button>
        </LoggedOutDropdownMenu.ListItem>
      </LoggedOutDropdownMenu.List>
    </LoggedOutDropdownMenu.Wrapper>
  );
};

LoggedOutDropdownMenu.Wrapper = styled.div`
  ${AccountDropdownMenuWrapper};
`;

LoggedOutDropdownMenu.List = styled(UnorderedList)`
  ${AccountDropdownMenuList};
`;

LoggedOutDropdownMenu.ListItem = styled.li`
  ${AccountDropdownMenuListItem};
`;

LoggedOutDropdownMenu.Button = styled.button`
  ${AccountDropdownMenuButton};
`;
